import { TFunction } from 'i18next'

export const getHelpCenterLink = (t: TFunction, countryId: string): string => {
  return (
    {
      DK: t('help.modal.help_center.link.denmark'),
      FR: t('help.modal.help_center.link.france'),
      NL: t('help.modal.help_center.link.netherlands'),
      DE: t('help.modal.help_center.link.germany'),
    }[countryId] || getHelpCenterLink(t, 'DK')
  )
}
